import parse from 'html-react-parser';

const AdItem = ({ ad, externalLink }) => {
  if (!ad.title && !ad.image) return null;

  return (
    <div className="post-box">
      <div className="p-2 mt-1">
        <a
          href={externalLink}
          target="_blank"
          rel="noopener noreferrer"
          className="text-decoration-none text-dark d-flex flex-column"
        >
          <div className="posted-inf">
            <div className="text-secondary">
              <small>Được tài trợ</small>
            </div>
            <div className="cont">{parse(ad.title)}</div>
            <div className="img-ad">
              <img src={ad.image} alt="image-ad" className="img-fluid rounded" />
            </div>
          </div>
        </a>
      </div>
    </div>
  );
};

export default AdItem;
